<script lang="ts">
  import type { TextTrack, PlayerInterface } from '@foundation-player/loader';
  import { getContext } from 'svelte';
  import TextTrackIcon from '../assets/icons/TextTrack.svelte';
  import type { FocusItem, FocusLayer } from '../focus-manager/focus-types';
  import type { PlayerStateContext } from '../types/player-state';
  import MenuButton from './menu/MenuButton.svelte';

  const TEXT_TRACK_OFF = 'text-track--off';

  const textTrackOffPlaceholder: TextTrack = {
    id: TEXT_TRACK_OFF,
    language: 'Aus',
  };

  export let player: PlayerInterface;
  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  const { availableTextTracks, activeTextTrack } = getContext<PlayerStateContext>('playerState');

  $: textTrack = $activeTextTrack ?? textTrackOffPlaceholder;

  const selectTrack = (event: CustomEvent<string>) => {
    if (event.detail === TEXT_TRACK_OFF) {
      player.disableTextTrack();
    } else {
      player.enableTextTrack(event.detail);
    }
  };

  const generateTrackLabel = (track?: TextTrack): string => (track ? track.label || track.language : 'Aus');

  const formatMenuItem = (trackId: unknown) => {
    const track = $availableTextTracks.find((track) => track.id === trackId);
    return generateTrackLabel(track);
  };
</script>

{#if $availableTextTracks.length > 0}
  <MenuButton
    label="Untertitel auswählen"
    menuItems={$availableTextTracks.map((track) => track.id).concat(TEXT_TRACK_OFF)}
    {formatMenuItem}
    selectedMenuItem={textTrack.id}
    on:selectItem={selectTrack}
    {focusLayer}
    {focusName}
  >
    <TextTrackIcon aria-hidden={true} />
  </MenuButton>
{/if}
